// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { OperatorConfiguration } from '@daml.js/utility-collateral-app-v2/lib/Utility/Collateral/App/Model/Configuration/Operator';
import { ERR_CRE_OP_CONF, SUC_CRE_OP_CONF } from '../../../utils/strings';
import { useCreateSubmission } from '../ledger/useSubmission';

export const useCreateOperatorConfiguration = () => {
  const { submit } = useCreateSubmission(OperatorConfiguration, SUC_CRE_OP_CONF, ERR_CRE_OP_CONF);
  return submit;
};
